module.exports = {
  HBL: '进口分单号',
  SONO: 'SONO',
  UserDefinedField1: '自定义字段1',
  UserDefinedField2: '自定义字段2',
  UserDefinedField3: '自定义字段3',
  UserDefinedField4: '自定义字段4',
  accordingToBusiness: '按业务',
  accordingToCharge: '按费用',
  accountStatementNo: '对账单号',
  accrued: '已计提',
  addCharge: '添加费用',
  adjustedOrNot: '是否调整',
  advanceMoneyOrNot: '是否代垫',
  airExport: '空运出口',
  airImport: '空运进口',
  all: '所有',
  amount: '金额',
  amountNotWrittenOff: '未销金额',
  amountRange: '金额区间',
  applicant: '申请人',
  applicationNo: '申请单号',
  applicationStatus: '申请状态',
  appliedForPaymentOrNot: '是否已申请付款',
  approval: '审批通过',
  auditor: '审核人',
  awaitBusinessApproval: '待业务审批',
  awaitFinancialApproval: '待财务审批',
  NosubmitWeaver: '待发送云平台',
  WeaverApproving: '云平台审批中',
  WeaverApproved: '云平台审批通过',
  back: '上一步',
  bankAccount: '银行账号',
  bankOfDeposit: '开户银行',
  billNo: '账单号',
  billPaymentNo: '付款申请单号',
  bookingNo: '订舱编号',
  businessApproval: '业务审批',
  officeApproval: '商务审批',
  businessCreateDate: '业务创建日期',
  businessDate: '业务日期',
  businessNumber: '业务编号',
  businessReferenceNumber: '业务参考号',
  businessStatus: '业务状态',
  businessType: '业务类型',
  bySettlementAgent: '通过结算代理',
  cancel: '取消',
  cancelPartialWriteOff: '部分撤销销账',
  carrier: '承运人',
  carrierId: '承运人',
  chargeItem: '费用名称',
  chargeOriginalAmount: '费用原金额',
  chargeOriginalCurrency: '费用原币种',
  chargeOriginalExchangeRate: '费用原汇率',
  chargeRemark: '费用备注',
  collectInvoice: '收票',
  confirmDate: '确认日期',
  confirmRemarks: '确认备注',
  confirmUser: '费用确认人',
  confirmationStatus: '确认状态',
  consignationCompany: '委托单位',
  contactPerson: '联系人',
  containerNo: '箱号',
  containerSizeAmount: '箱型/箱量',
  controlledOrNot: '是否受控',
  couldNotSearhWriteOffJobFromThisWindow: '注：此界面已过滤掉完全核销的费用/业务',
  creator: '创建人',
  currency: '币种',
  customJobType: '自定义业务类型',
  customer: '客户',
  customerContact: '业务联系人',
  customerService: '客服',
  dateOfApplication: '申请日期',
  dateOfCreation: '创建日期',
  delete: '删除',
  department: '部门',
  departmentApproval: '部门审批',
  destinationAgent: '目的港代理',
  domesticInternational: '国内/国外',
  edit: '修改',
  edit2: '编辑',
  eta: 'ETA',
  etd: 'ETD',
  atd: 'ATD',
  ata: 'ATA',
  exchangeRate: '汇率',
  export: '出口',
  exportExcel: '导出Excel',
  exportPDF: '导出PDF',
  feeStatus: '费用状态',
  financialApproval: '财务审批',
  financialAudit: '财务审核',
  financialDate: '财务日期',
  generatedBillsOrNot: '是否已生成账单',
  import: '进口',
  importhbl: '进口分单号',
  includeReceivables: '包含应收',
  inputBy: '费用创建人',
  inquiryWay: '查询方式',
  invalid: '作废',
  invoiceDate: '应收开票日期',
  invoiceDateAll: '开票日期',
  invoiceHeader: '开票抬头',
  sellerInvoiceTitle: '销方开票抬头',
  dateModified: '更改时间',
  modifiedBy: '更改人',
  invoiceNo: '发票号码',
  invoiceState: '应收开票状态',
  invoicedOrNot: '是否已开票',
  lackInvoiceFlag: '是否缺票',
  uploadAttachmentFlag: '是否上传附件',
  invoicingMethod: '开票方式',
  isNeedInvoice: '是否需要开票',
  isReceivable: '收支类型',
  itemNo: '项目编号',
  lclMasterOrNot: '是否小票',
  masterFlagOrNot: '是否主票',
  mbl: '主单号',
  methodOfPayment: '付款方式',
  monetaryEquivalent: '折算金额',
  needInvoice: '是否需要开票',
  new: '新增',
  newActualPayment: '新增实付',
  newActualReceipt: '新增实收',
  newPaymentRequest: '创建付款申请',
  changePaymentRequest: '修改付款申请',
  processPaymentRequest: '办理',
  deletePaymentRequest: '删除申请',
  submintPaymentRequest: '提交申请',
  next: '下一步',
  notSubmitted: '未提交',
  oceanExport: '海运出口',
  oceanImport: '海运进口',
  operation: '操作',
  originalAmount: '原金额',
  payReceiveDate: '收付日期',
  payables: '应付',
  payment: '付款',
  paymentDate: '付款日期',
  paymentPeriod: '付款期限',
  paymentPeriodUnit: '付款期限单位',
  paymentType: '支付类型',
  invoiceNumber: '发票号',
  // 日常付款申请：款项所属部门（显示文案）
  enterpriseWechatDepartment: '款项所属部门',
  enterpriseWechatCompany: '付款公司',
  oneEnterpriseWechatCompany: '付款公司',
  enterpriseWechatBelongCompany: '所属公司',
  enterpriseWechatType2Company: '付款公司',
  enterpriseWechatType2Department: '款项所属部门',
  enterpriseWechatType1OfficeCity: '办公地点',
  enterpriseWechatType4OfficeCity: '办公城市',
  enterpriseWechatType4Company: '付款公司',
  enterpriseWechatType4PayMethod: '付款方式',
  // 以下为企微模板匹配使用的标题，可与展示文案解耦
  // 日常付款申请：模板字段标题「款项所属部门」
  enterpriseWechatDepartmentMatch: '款项所属部门',
  enterpriseWechatCompanyMatch: '付款公司',
  oneEnterpriseWechatCompanyMatch: '所属公司：',
  enterpriseWechatBelongCompanyMatch: '所属公司',
  enterpriseWechatType2CompanyMatch: '付款公司',
  enterpriseWechatType2DepartmentMatch: '费用所属部门',
  enterpriseWechatType1OfficeCityMatch: '办公地点',
  enterpriseWechatType4OfficeCityMatch: '办公城市',
  enterpriseWechatType4CompanyMatch: '付款公司',
  enterpriseWechatType4PayMethodMatch: '付款方式',
  enterpriseWechatPayMethod: '付款方式',
  enterpriseWechatPayMethodMatch: '付款方式',
  enterpriseWechatFeeType: '付款/费用类型',
  enterpriseWechatFeeTypeMatch: '付款/费用类型',
  enterpriseWechatWaterNotifier: '水单通知人',
  enterpriseWechatWaterNotifierMatch: '水单通知人',
  // 专项费用申请：费用所属部门（显示 + 匹配文案）
  enterpriseWechatSpecialDepartment: '费用所属部门',
  enterpriseWechatSpecialDepartmentMatch: '费用所属部门：',
  // 所在部门（各付款类型通用：显示 + 匹配文案）
  enterpriseWechatLocatedDepartment: '所在部门',
  enterpriseWechatLocatedDepartmentMatch: '所在部门',
  enterpriseWechatFieldRequired: '{0}不能为空',
  enterpriseWechatWaterNotifierMissing: '该用户未绑定企微联系人，请联系管理员绑定',
  planner: '航线负责人',
  portOfDestination: '目的港',
  portOfDestinationAirport: '目的港(空港)',
  portOfDestinationSeaport: '目的港(海港)',
  portOfDischargeAirport: '卸货港(空港)',
  portOfDischargeSeaport: '卸货港(海港)',
  portOfLoading: '起运港',
  portOfLoadingAirport: '起运港(空港)',
  portOfLoadingSeaport: '起运港(海港)',
  portOfTransfer: '中转港',
  print: '打印',
  quantity: '数量',
  query: '查询',
  receipt: '收款',
  receiptDate: '收款日期',
  receivables: '应收',
  receivablesWriteOfStatus: '应收核销状态',
  relatedJob: '往来关联号',
  remarks: '备注',
  replaceInvoiceRemark: '替票说明',
  purpose: '用途',
  postscript: '交易附言',
  preRemarks: '预收付备注',
  ticketNo: '票据号',
  workflowNo: '流程编号',
  removeCharge: '移除费用',
  return: '退回',
  sales: '销售',
  save: '保存',
  saveAndAdd: '保存并新增',
  separateNumber: '分单号',
  settleAccountsTo: '结算对象',
  settlementAgent: '结算代理',
  settlementCompany: '结算单位',
  customerChineseName: '委托单位中文名',
  settlementType: '结算类型',
  solicitationType: '揽货类型',
  status: '状态',
  submit: '提交',
  taxAmount: '税额',
  taxExcludedPrice: '不含税价',
  taxIncludedPrice: '含税价',
  taxRate: '税率',
  theAmountOfWriteOffs: '核销金额',
  currencyAmountOfWriteOffs: '核销金额分币种合计',
  total: '合计',
  totalCurrency: '分币种合计',
  totalWriteOffs: '核销总计',
  trustFromJob: '委托关联号',
  uncheck: '取消选中',
  unit: '单位',
  unitPrice: '单价',
  unpaid: '未付清',
  vessel: '船名',
  vesselAndVoyage: '船名航次',
  viewDetails: '查看明细',
  viewWriteOffList: '查看销账明细',
  voyage: '航次',
  warehouseNo: '进仓编号',
  writeOffCurrency: '核销币种',
  writeOffDate: '销账日期',
  writeOffExchangeRate: '核销汇率',
  writeOffList: '销账明细',
  writeOffSerialNumber: '销账流水号',
  wroteOffOrNot: '是否已核销',
  approveHistoryNode: '审批节点',
  invoice_voucherDate: '凭证日期2',
  time: '时间',
  approveTime: '审批时间',
  operator: '操作人',
  approval_results: '审批结果',
  applicationDepartment: '申请部门',
  settleDepartmentPrefix: '结算部门',
  writeOffStatus: '核销状态',
  moneyWriteOffStatus: '费用核销状态',
  sendWeaver: '发送云平台',
  receivablesAndPayables: '应收应付',
  operationDate: '操作日期',
  newPaymentRequest_SR: '创建付款申请',
  deletePaymentRequest_SR: '删除申请',
  sendWeaver_SR: '发送云平台',
  viewDetails_SR: '查看',
  lastInvoicingDate: '最晚开票日期',
  paymentRequestState: '付款申请状态',
  Cargo_ApplicantPassTips: '是否同意此付款申请？',
  Cargo_ApplicantReturnToSubmitterTips: '此申请将退回到提交人，是否确认退回？',
  Cargo_ApplicantReturnToBusinessTips: '此申请将退回到业务审批人，是否确认退回？',
  Cargo_ApplicantReturnToFinancialTips: '此申请将退回到财务审批人，是否确认退回？',
  approveReason: '请输入同意理由',
  returnReason: '请输入退回原因',
  bdApproveState: '业务审批状态',
  ccApproveState: '财务审批状态',
  finApproveState: '最终审批状态',
  receiptPaymentNo: '收付款凭证号',
  // REQ-0040 专项费用申请提交时企微审批路由提示（分支判定见 specialFeeApprovalRoute.js，口径对齐后端 ApprovalUtils）
  specialFeeExpenseApprovalRouteTip: '检测到专项费用申请金额 < 50000，我们将会发起到企微的“费用报销申请”审批中。',
  specialFeeSpecialApprovalRouteTip: '检测到专项费用申请金额 > 50000，我们将会发起到企微的“专项费用申请”审批中。',
  specialFeeSpecialApprovalRouteTipKh: '我们将会发起到企微的“专项费用申请”审批中。',
  confirmSubmitTip: '是否确认提交？'
}
